// convo-ai api contract: https://hello.atlassian.net/wiki/spaces/AM3/pages/5214503181/Suggested+Comment+Reply+Convo-AI+API+Design
export const PRODUCT_TYPES_CONVO_AI = {
	JWM: 'JIRA_WORK_MANAGEMENT',
	JSW: 'JIRA_SOFTWARE',
} as const;

export type SuggestedCommentReplyConvoAgentProduct =
	(typeof PRODUCT_TYPES_CONVO_AI)[keyof typeof PRODUCT_TYPES_CONVO_AI];

export const SuggestedCommentReplyAgentCommentType = {
	QUICK_REPLY: 'QUICK_REPLY',
	QUESTION: 'QUESTION',
	SUGGESTION: 'SUGGESTION',
	JIRA_STATUS_UPDATE: 'JIRA_STATUS_UPDATE',
	JIRA_COMMENT_REPLY: 'JIRA_COMMENT_REPLY',
	JIRA_ASSIGNEE_MISSING: 'JIRA_ASSIGNEE_MISSING',
	JIRA_DESCRIPTION_MISSING: 'JIRA_DESCRIPTION_MISSING',
	JIRA_MOTIVATION: 'JIRA_MOTIVATION',
} as const;

export type SuggestedCommentReplyAgentCommentType =
	(typeof SuggestedCommentReplyAgentCommentType)[keyof typeof SuggestedCommentReplyAgentCommentType];

export const SUGGESTED_COMMENT_AGENT_AI_FEATURE_PATH = 'ai-feature/suggested-comment-reply';
export const SUGGESTED_COMMENT_AGENT_EXPERIENCE_ID = 'suggested-comment-reply';

export type SuggestedCommentReplyCommentTypes = SuggestedCommentReplyAgentCommentType[];

export type SuggestedCommentReplyAgentRequest = {
	object_id: string; // issue-key
	locale: string;
	product: SuggestedCommentReplyConvoAgentProduct;
	comment_type?: SuggestedCommentReplyCommentTypes;
	adf_format?: boolean;
};

export type SuggestedCommentReplyAgentComment = {
	commentType: SuggestedCommentReplyAgentCommentType;
	text: string;
	adf: object | null;
};

export type SuggestedCommentReplyAgentResponse = {
	commentSuggestions?: SuggestedCommentReplyAgentComment[];
};
